import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
// import CustomTextInput from "../../../components/HrManagements/CustomInput";
import { CustomBox } from "../../../components/HrManagements/CustomBox";
import { CommonHeader } from "../../../components/HrManagements/CommonHeader";
// import { CustomBottom } from "../../../components/HrManagements/CustomBottom";
// import CustomSelect from "../../../components/HrManagements/CustomSelect";
// import CustomFileInput from "../../../components/HrManagements/CustomFileInput";
// import { Formik } from "formik";
import { useSearchParams } from "react-router-dom";
import { API_AXIOS } from "../../../http/interceptor";
import Apis from "../../../utils/apis";
// import { toast } from "react-toastify";
import { Stepper, Step, StepLabel } from "@mui/material";
import { styled } from "@mui/material/styles";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import DoneIcon from "@mui/icons-material/Done";
import EmergencyContact from "./EmergencyContact";
import UserIdProof from "./UserIdProof";
import { PersonalInfo } from "./PersonalInfo";
import { useSelector } from "react-redux";
import { isAdmin } from "../../../utils/menuItems";
// import { Sync } from "@mui/icons-material";

/*Stepper Start */
const steps = ["PERSONAL INFORMATION", "EMERGENCY CONTACT", "ID PROOF"];
const ColorStepConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 13,
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    backgroundColor: "#2c67c6",
    zIndex: 1,
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    backgroundColor: "#2c67c6",
    zIndex: 1,
  },
  [`.${stepConnectorClasses.line}`]: {
    height: 5,
    border: 0,
    backgroundColor: "#D9D9D9",
    padding: "3px 0px",
    borderRadius: 10,
  },
}));

const QontoStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  color: ownerState.active
    ? "green"
    : theme.palette.mode === "dark"
    ? theme.palette.divider[700]
    : "red",
  display: "flex",
  height: 30,
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1,
}));

function QontoStepIcon(props) {
  const { active, completed, className, step } = props;
  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Box
          sx={{
            backgroundColor: "#2c67c6",
            width: "50px",
            height: "50px",
            alignItem: "center",
            textAlign: "center",
            borderRadius: "50%",
            padding: "7px 7px",
          }}
        >
          <div
            className="QontoStepIcon-circle"
            style={{ backgroundColor: "red" }}
          >
            {step}
          </div>
          <DoneIcon style={{ color: "#FFFFFF", fontSize: "2rem" }} />
        </Box>
      ) : (
        <Box
          sx={{
            backgroundColor: "#8F9BB3",
            width: "50px",
            height: "50px",
            alignItem: "center",
            textAlign: "center",
            borderRadius: "50%",
            padding: "7px 7px",
          }}
        >
          <div className="QontoStepIcon-circle">{step}</div>
          <DoneIcon style={{ color: "#FFFFFF", fontSize: "2rem" }} />
        </Box>
      )}
    </QontoStepIconRoot>
  );
}

export const HorizontalStepper = ({ activeStep }) => {
  return (
    <Box sx={{ width: "100%", marginTop: "2.4rem" }}>
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        connector={<ColorStepConnector />}
      >
        {steps.map((label, index) => (
          <Step key={label} completed={index < activeStep}>
            <StepLabel
              StepIconComponent={QontoStepIcon}
              sx={{
                "& .MuiStepLabel-label": {
                  color: "#202020",
                  fontSize: "16px",
                  fontWeight: "600",
                  "@media(max-width: 600px)": {
                    fontSize: "14px",
                  },
                },
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

/*Stepper end */

export const UserApplication = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const token = searchParams.get("token");
  const [user, setUser] = useState({});
  const [currentStep, setCurrentSteps] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");
  const { auth } = useSelector((state) => state.auth);
  const checkAdmin = isAdmin.includes(auth?.role);

  const handleNextStep = () => {
    setCurrentSteps(currentStep + 1);
  };

  const handlePrevStep = () => {
    setCurrentSteps(currentStep - 1);
  };

  useEffect(() => {
    let active = true;
    setLoading(true);
    setLoadError("");
    setSubmitted(false);
    setCurrentSteps(0);
    const getData = async () => {
      try {
        const { data } = await API_AXIOS.get(
          `${Apis.getHrmsUserDetails}/${id}`,
          { ...(token ? { headers: { "x-invitation-token": token } } : {}), timeout: 15000 },
        );
        if (!active) return;
        setUser(data);
        // Use persisted state, not the invitation URL's original `filled` value.
        // HR can reopen submitted applications by granting editable fields.
        setSubmitted(Boolean(token && data.isFilled && !data.isEditable?.length));
      } catch (error) {
        if (!active) return;
        const message = error.response?.data;
        setLoadError(typeof message === "string" ? message : message?.message || "Unable to load your application. Please refresh and try again.");
      } finally {
        if (active) setLoading(false);
      }
    };

    if (id) {
      getData();
    } else {
      setLoadError("This application link is incomplete. Please use the invitation link provided to you.");
      setLoading(false);
    }
    return () => { active = false; };
  }, [id, token]);

  if (loading || loadError) {
    return (
      <CustomBox style={{ padding: "4rem 2rem", textAlign: "center" }}>
        <Typography role={loadError ? "alert" : "status"}>
          {loadError || "Loading your application…"}
        </Typography>
      </CustomBox>
    );
  }

  if (submitted) {
    return (
      <Box sx={{ width: "100%" }}>
        <CustomBox style={{ padding: "4rem 2rem", textAlign: "center" }}>
          <CommonHeader
            title={"Application submitted"}
            style={{
              display: "flex",
              justifyContent: "center",
              fontSize: "25px",
            }}
          />
          <Typography sx={{ mt: 2, color: "#606060" }}>
            Your information has been submitted for approval. You can sign in
            after an administrator approves your application.
          </Typography>
        </CustomBox>
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%" }}>
      <CustomBox style={{ padding: "2rem 2rem" }}>
        <CommonHeader
          title={"User Application"}
          style={{
            display: "flex",
            justifyContent: "center",
            fontSize: "25px",
          }}
        />
        <HorizontalStepper activeStep={currentStep} />
        {currentStep === 0 && (
          <PersonalInfo
            onNext={handleNextStep}
            onPrev={handlePrevStep}
            isAdmin={checkAdmin}
            user={user}
          />
        )}
        {currentStep === 1 && (
          <EmergencyContact
            onNext={handleNextStep}
            onPrev={handlePrevStep}
            isAdmin={checkAdmin}
            user={user}
          />
        )}
        {currentStep === 2 && (
          <UserIdProof
            onNext={handleNextStep}
            onPrev={handlePrevStep}
            onComplete={() => setSubmitted(true)}
            isAdmin={checkAdmin}
            user={user}
          />
        )}
      </CustomBox>
    </Box>
  );
};
